module.exports = __webpack_public_path__ + "static/media/delete-line.9b112ec8.svg";